@if (!loading) {
    <div>
        @if (companyData.isSingleCompany) {
            <tapestry-nav-org-label
                class="nav-org-label"
                [labelText]="selectedCompany.name"
            >
            </tapestry-nav-org-label>
        } @else {
            <div class="dropdown-trigger">
                {{ selectedCompany?.name }}
                <tapestry-icon-button
                    mat-button
                    [matMenuTriggerFor]="menu.matMenu"
                    iconName="navigation_down_bold"
                    data-tracking="companySwitchChevron"
                    data-testing="companySwitchChevron"
                >
                </tapestry-icon-button>
            </div>
            <tapestry-category-dropdown
                #menu
                [items]="items"
                filterable
                (selectedItem)="handleSelection($event)"
                [filterPlaceholder]="
                    'changecompany.pickcompanyplaceholder' | translate
                "
            ></tapestry-category-dropdown>
        }
    </div>
}
